/**
 * [和德保险企业账户]
 */

import http from '@/assets/api/http';

// 和德保险企业账户余额查询（金额单位：元）
export async function queryBalance(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.HedeInsureMisService.queryBalance', params, 'POST');
}

// 和德保险企业账户充值（金额单位：元），返回 payUrl 供跳转支付
export async function charge(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.HedeInsureMisService.charge', params, 'POST');
}
